var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25.5,
    r: 25.5,
    fill: "#3485C3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.7083 25.043H33.2292C33.2292 26.1221 32.9958 27.1284 32.6021 28.0326L34.3958 29.8263C35.2125 28.3971 35.7083 26.7784 35.7083 25.043ZM29.8458 25.2909C29.8458 25.2034 29.875 25.1305 29.875 25.043V16.293C29.875 13.8721 27.9208 11.918 25.5 11.918C23.0792 11.918 21.125 13.8721 21.125 16.293V16.5555L29.8458 25.2909ZM14.2271 13.3763L12.375 15.2284L21.1396 23.993V25.043C21.1396 27.4638 23.0792 29.418 25.5 29.418C25.8208 29.418 26.1417 29.3742 26.4479 29.3013L28.8688 31.7221C27.8333 32.2034 26.6813 32.4805 25.5 32.4805C21.475 32.4805 17.7708 29.418 17.7708 25.043H15.2917C15.2917 30.0159 19.2583 34.1284 24.0417 34.843V39.6263H26.9583V34.843C28.2854 34.6534 29.5396 34.1867 30.6625 33.5305L36.7729 39.6263L38.625 37.7742L14.2271 13.3763Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicOff);
export default __webpack_public_path__ + "static/media/MicOff.af05259d7a2e70ff7eacc12726fddde3.svg";
export { ForwardRef as ReactComponent };